import PassengerCounter from 'components/forms/bookingWidget/PassengerCounter';
import { Box } from 'components/primitives/box';
import type { UseFormMethods } from 'react-hook-form';

interface PassengerInputProps {
  register: UseFormMethods['register'];
  isMessageOwner?: boolean;
}
export default ({ register, isMessageOwner }: PassengerInputProps) => (
  <Box>
    <PassengerCounter isMessageOwner={isMessageOwner} />
    <input type="hidden" ref={register({ required: 'Please enter passenger amount' })} name="passengers" />
  </Box>
);
